export default __webpack_public_path__ + "static/media/tamplate.e55d2608.png";